import { useIntl } from 'react-intl';

import { getGuidePersonnel, Personnel } from '@/utils/app/guide';
import ProfileIconFilled from 'icons/profile-filled.svg';

import {
	AvatarIcon,
	PersonImage,
	PersonImageWrapper,
	PersonInfoWrapper,
	PersonName,
	PersonRole,
	PersonWrapper,
	Wrapper,
} from './styles';
import { GuidePersonnelProps } from './types';

const GuidePersonnel = ({ program }: GuidePersonnelProps) => {
	const { formatMessage } = useIntl();

	const guidePersonnel = getGuidePersonnel(program);

	const getPersonnelImage = (person: Personnel) => {
		return person.image ? (
			<PersonImage src={person.image} alt="" />
		) : (
			<AvatarIcon as={ProfileIconFilled}></AvatarIcon>
		);
	};

	if (guidePersonnel.length === 0) {
		return null;
	}

	return (
		<Wrapper>
			{guidePersonnel.map(person => (
				<PersonWrapper key={person.id}>
					<PersonImageWrapper>{getPersonnelImage(person)}</PersonImageWrapper>
					<PersonInfoWrapper>
						<PersonName>{person.copy}</PersonName>
						<PersonRole>{formatMessage(person.heading)}</PersonRole>
					</PersonInfoWrapper>
				</PersonWrapper>
			))}
		</Wrapper>
	);
};

export default GuidePersonnel;
